import React from 'react';
import Slider from 'react-slick';
import './ourclients.css';

import one from "../../assets/company logo/f1.png";
import two from "../../assets/company logo/f4.jpg";
import three from "../../assets/company logo/ks.jpeg";
import four from "../../assets/company logo/newsky.jpeg";
import five from "../../assets/company logo/nsp.jpeg";
import six from "../../assets/company logo/zuari.jpeg";
import seven from "../../assets/company logo/tripp.jpg";
import eight from "../../assets/company logo/rediteee.jpeg";

function OurClients() {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 6,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024, // tablets
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768, // small tablets
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480, // mobile phones
        settings: {
          slidesToShow: 1,  // ✅ Show only one logo on mobile
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <section className="our-clients-section">
      <div className="our-clients">
        <section className="section-margin">
          <div className="heading-for-all" data-aos="fade-up">
            <h2>Our Clients</h2>
          </div>
        </section>

        <Slider {...settings}>
          <div className="client-item"><img src={one} alt="Client 1" /></div>
          <div className="client-item"><img src={two} alt="Client 2" /></div>
          <div className="client-item"><img src={three} alt="Client 3" /></div>
          <div className="client-item"><img src={four} alt="Client 4" /></div>
          <div className="client-item"><img src={five} alt="Client 5" /></div>
          <div className="client-item"><img src={six} alt="Client 6" /></div>
          <div className="client-item"><img src={seven} alt="Client 7" /></div>
          <div className="client-item"><img src={eight} alt="Client 8" /></div>
        </Slider>
      </div>
    </section>
  );
}

export default OurClients;
